import { Route, Routes, useLocation, useNavigate } from "react-router-dom"
import NotFound from "../components/NotFound"
import Users from "../pages/Admin/Users"
import Dashboard from "../pages/Agency/Dashboard"
import Application from "../pages/Agency/Application"
import LoginMFA from "../pages/Agency/LoginMFA"
import Login from "../pages/Agency/Login"
import Applications from "../pages/Admin/ViewApplications"
import AgenciesAndContact from "../pages/Admin/Agencies"
import PrivacyPolicyAndTermsAndConditions from "../pages/Agency/PrivacyPolicyAndTermsAndConditions"
import Reporting from "../pages/Admin/Reporting"
import Profile from "../pages/Agency/Profile"
import AdminProfile from "../pages/Admin/AdminProfile"
import Endorsements from "../pages/Admin/Endorsements"
import { useDispatch, useSelector } from "react-redux"
import React, { useEffect } from "react"
import { getCurrentUser } from "../data/authenticationSlice"
import { authRoutes } from "../constant/utils"

export const AdminRoutes = ({ site }) => {
    const location = useLocation()
    const isAuthRoute = authRoutes?.includes(location.pathname)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isAuthenticated, fetchStatus } = useSelector((state) => state.authentication)

    useEffect(() => {
        if (!isAuthenticated && fetchStatus && fetchStatus !== "loading") {
            navigate("/admin/login")
        }
    }, [isAuthenticated, fetchStatus])

    useEffect(() => {
        let isMFA = location.pathname.endsWith("login-mfa")

        if (!isMFA) {
            dispatch(getCurrentUser()).then(({ payload }) => {
                if (!payload && !isAuthRoute && !location.pathname.endsWith("/login")) {
                    let loc = location.pathname.split("/")[1]
                    if (!!loc) navigate(`/${loc}/login`)
                }
            })
        }
    }, [site])

    return (
        <Routes>
            {isAuthenticated && (
                <React.Fragment>
                    <Route
                        path="/gai-users"
                        element={<Users />}
                    />
                    <Route
                        path="/profile"
                        element={<AdminProfile />}
                    />
                    <Route
                        path="/agencies-and-contracts"
                        element={<AgenciesAndContact />}
                    />

                    <Route
                        path="/reporting"
                        element={<Reporting />}
                    />
                    <Route
                        path="/endorsements"
                        element={<Endorsements />}
                    />
                    <Route
                        path="/create-application"
                        element={<Application type="adminCreateApplication" />}
                    />
                    <Route
                        path="/applications"
                        element={<Applications />}
                    />
                    {/* <Route
                        path="/*"
                        element={<Applications />}
                    /> */}
                    <Route
                        path="*"
                        element={<NotFound />}
                    />
                </React.Fragment>
            )}
            <Route
                path="/login"
                element={<Login />}
            />
            <Route
                path="/login-mfa"
                element={<LoginMFA />}
            />
        </Routes>
    )
}

export const AgencyRoutes = ({ site }) => {
    const isAuthRoute = authRoutes?.includes(location.pathname)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isAuthenticated, fetchStatus } = useSelector((state) => state.authentication)

    useEffect(() => {
        if (!isAuthenticated && fetchStatus && fetchStatus !== "loading") {
            navigate("/agency/login")
        }
    }, [isAuthenticated, fetchStatus])

    useEffect(() => {
        let isMFA = location.pathname.endsWith("login-mfa")
        if (!isMFA) {
            dispatch(getCurrentUser()).then(({ payload }) => {
                if (!payload && !isAuthRoute && !location.pathname.endsWith("/login")) {
                    let loc = location.pathname.split("/")[1]
                    if (!!loc) navigate(`/${loc}/login`)
                }
            })
        }
    }, [site])

    return (
        <Routes>
            {isAuthenticated && (
                <React.Fragment>
                    <Route
                        path="/dashboard"
                        element={<Dashboard />}
                    />

                    <Route
                        path="/profile"
                        element={<Profile />}
                    />
                    <Route
                        path="/create-application"
                        element={<Application type="agencyApplication" />}
                    />
                    {/* <Route
                        path="/*"
                        element={<Dashboard />}
                    /> */}
                    <Route
                        path="*"
                        element={<NotFound />}
                    />
                </React.Fragment>
            )}
            <Route
                path="/login-mfa"
                element={<LoginMFA />}
            />
            <Route
                path="/privacy-policy-and-terms-and-conditions"
                element={<PrivacyPolicyAndTermsAndConditions />}
            />
            <Route
                path="/login"
                element={<Login />}
            />
        </Routes>
    )
}
